import React, { useEffect, useState } from "react";
import Header from '../../components/Header/index'
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from '../../components/Breadcrumb/index';
import StoryService from "../../services/story.service";
import { Link } from "react-router-dom";
import TrainingService from "../../services/training.service";
import SingleCourse from "../../components/Course/SingleCourse";

const Training=()=>{
    const [trainingList,setTrainingList]=useState([]);
    const [extra,setExtra]=useState({});
    const [query,setQuery]=useState({});

    // const stories=[
    //     {poster:"./img/story/poster-1.png"},
    //     {poster:"./img/story/poster-2.png"},
    //     {poster:"./img/story/poster-1.png"},

    //     {poster:"./img/story/poster-1.png"},
    //     {poster:"./img/story/poster-2.png"},
    //     {poster:"./img/story/poster-1.png"},

    //     {poster:"./img/story/poster-1.png"},
    //     {poster:"./img/story/poster-2.png"},
    //     {poster:"./img/story/poster-1.png"},
    // ];

    // const handlePagination=(page,type)=>{
    //     let query={};
    //     switch(type){
    //         case "prev":query.page=extra.page -1;break;
    //         case "next":query.page=extra.page +1;break;
    //         default:query.page=page;
    //     }
    //     setQuery(query);
    // }

    useEffect(()=>{
        TrainingService.list(query)
        .then(res=>{setTrainingList(res?.data);setExtra(res?.extra)})
        .catch(err=>console.log(err));
    },[query]);

    return (
        <>
        <Header/>
        <Breadcrumb pageTitle={"Training"}/>
        <section className="py-4 mb-5">
            <h2 className="display-4 fw-bold my-5 text-center text-black">Our <strong style={{color:"#FE7743"}} className="fw-semibold">Trainings</strong></h2>
            <div className="container">
                <div className="row row-cols-sm-2 row-cols-lg-3 g-4">
                    {
                        trainingList?.map((data,idx)=>(

                            <div key={idx} className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 wow animate__fadeInUp mb-4" data-wow-duration="0.3s">
                            {
                                <SingleCourse
                                    courseID={data?._id}
                                    courseImg= {`${data?.thumbnailImgUrl}`}
                                    courseTitle= {data?.title}
                                    // courseName= {data.name}
                                    // courseLesson= {data.lesson}
                                    // courseEnrolled= {data.enrolled}
                                    // coursePrice= {data.price}
                                    description={data?.shortDescription}
                                    slug={data?.slug}
                                    type={"training"}
                                />
                            }

                        </div>

                            // <div style={{height:"322px",width:"400px",transition:".3s"}} key={idx} className="col-12 position-relative">
                            //     <Link to={`/training-detail/${item?.slug}`}>
                            //     <img src={item?.thumbnailImgUrl} width={380} height={300} className="shadow border-3 border-white p-2 object-fit-cover"/>

                            //     </Link>
                            // </div>


                        ))
                    }
                </div>

                {/* <ul className="back-pagination pt---20">
                <li className="back-next">
                    <button onClick={()=>handlePagination(undefined,"prev")}>
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 12H19M5 12L11 6M5 12L11 18" stroke="#5B5F64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></button></li>
                    <li><button style={{background: "#3270FC", color: "#ffffff"}} onClick={()=>handlePagination(Number(extra.page))} >{extra.page}</button></li>
                    <li><button onClick={()=>handlePagination(Number(extra.page +1))} >{extra.page +1}</button></li>
                    <li className="back-next"><button onClick={()=>handlePagination(undefined,"next")}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></button></li>
                </ul> */}

            </div>
        </section>
        <FooterTwo/>
        </>


    )
};

export default Training;